import React, { useState, useEffect } from "react";
import getApiBaseUrl from "../config/api";
import { apiCall } from "../config/api";
import { useNavigate } from "react-router-dom";
import { auth, storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  CircularProgress,
  Paper,
  Snackbar,
  Autocomplete,
  Avatar,
  IconButton,
  Tooltip,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import {
  Check as CheckIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  FilterList as FilterListIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  SelectAll as SelectAllIcon,
  Clear as ClearAllIcon,
  CloudUpload as UploadIcon,
} from "@mui/icons-material";

const CSVBulkPinCreationPage = () => {
  const [csvRows, setCsvRows] = useState([]);
  const [csvPreview, setCsvPreview] = useState({
    total: 0,
    valid: 0,
    invalid: 0,
    invalidRows: [],
  });
  const [csvFileName, setCsvFileName] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [campaignUsers, setCampaignUsers] = useState([]);
  const [selectedCampaignUser, setSelectedCampaignUser] = useState(null);
  const [userFetchError, setUserFetchError] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [filters, setFilters] = useState({
    name: "",
    category: "",
    duration: "",
    textContent: "",
  });
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();

  const [pinTemplate, setPinTemplate] = useState({
    textContent: "",
    category: "Standard",
    duration: "1_day",
    audioUrl: "",
    imageUrl: "",
    audioInputType: "url", // "url" or "file"
    pinOwnerName: "",
    pinOwnerPhotoUrl: "",
    marker: { type: "profile", size: "medium" },
  });
  const [audioUploading, setAudioUploading] = useState(false);
  const [rowAudioUploading, setRowAudioUploading] = useState({});

  const [batchProgress, setBatchProgress] = useState({
    isProcessing: false,
    total: 0,
    completed: 0,
    successful: 0,
    failed: 0,
    errors: [],
  });
  const [successSnackbar, setSuccessSnackbar] = useState(false);

  const categories = ["Standard", "Event", "Promotion", "Warning"];
  const durationOptions = [
    { value: "1_hour", label: "1 Saat" },
    { value: "6_hours", label: "6 Saat" },
    { value: "12_hours", label: "12 Saat" },
    { value: "1_day", label: "1 Gün" },
    { value: "3_days", label: "3 Gün" },
    { value: "1_week", label: "1 Hafta" },
    { value: "1_month", label: "1 Ay" },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      setUserFetchError(null);
      try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          throw new Error("Oturum bulunamadı. Lütfen tekrar giriş yapın.");
        }
        const idToken = await currentUser.getIdToken();

        const response = await apiCall(`/api/admin/users`, {
          method: "GET",
          headers: { Authorization: `Bearer ${idToken}` },
        });

        const rawUsers = response.users || [];
        const seenEmails = new Set();
        const usersList = rawUsers
          .map((user) => ({
            id: user.id,
            name: user.displayName,
            photoUrl: user.photoURL,
            email: user.email,
          }))
          .filter((user) => {
            if (!user.name || !user.email) return false;
            if (seenEmails.has(user.email)) return false;
            seenEmails.add(user.email);
            return true;
          });

        usersList.push({
          id: "new_user",
          name: "Yeni Kullanıcı Oluştur",
          email: "",
          photoUrl: "",
        });
        setCampaignUsers(usersList);
      } catch (err) {
        console.error("Kullanıcılar getirilirken hata oluştu:", err);
        const errorMessage = err.response?.data?.error || err.message;
        setUserFetchError(errorMessage);
        setCampaignUsers([]);
      }
    };
    fetchUsers();
  }, []);

  const downloadSampleCsv = () => {
    const headers = [
      "name",
      "address",
      "lat",
      "lng",
      "textContent",
      "audioUrl",
      "imageUrl",
      "category",
      "duration",
      "pinOwnerName",
      "pinOwnerPhotoUrl",
      "markerType",
      "markerSize",
      "markerColor",
      "markerLetter",
      "markerIconUrl",
      "markerIconScale",
    ];
    const sample = [
      headers.join(","),
      'Adana Merkez,"Seyhan/Adana",36.9914,35.3310,"Adana şehir merkezi açıklaması",https://example.com/audio1.mp3,https://example.com/image1.jpg,Standard,1_week,Süleyman Baba,https://example.com/photo.jpg,dot,medium,#ff2d55,,,',
      'Antalya Kaleiçi,"Kaleiçi/Antalya",36.8969,30.7133,"Tarihi Kaleiçi bölgesi",,,Premium,1_month,,profile,large,,,,',
      'Mersin Liman,"Mersin Merkez",36.8121,34.6415,"Mersin liman bölgesi",,https://example.com/image2.jpg,Standard,3_days,,,letter,small,#00ff00,M,,',
    ].join("\n");
    const blob = new Blob([sample], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "putpin_template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const parseCsvText = (text) => {
    const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
    if (lines.length === 0)
      return {
        rows: [],
        preview: { total: 0, valid: 0, invalid: 0, invalidRows: [] },
      };

    let startIdx = 0;
    let headerMap = {};
    const header = lines[0].toLowerCase();

    if (
      header.includes("name") &&
      header.includes("lat") &&
      header.includes("lng")
    ) {
      startIdx = 1;
      // Header'ları parse et ve index mapping oluştur
      const headerCols = [];
      let cur = "";
      let inQuotes = false;

      for (let c = 0; c < lines[0].length; c++) {
        const ch = lines[0][c];
        if (ch === '"') {
          inQuotes = !inQuotes;
          continue;
        }
        if (ch === "," && !inQuotes) {
          headerCols.push(cur.trim().toLowerCase());
          cur = "";
        } else {
          cur += ch;
        }
      }
      headerCols.push(cur.trim().toLowerCase());

      // Header mapping oluştur
      headerCols.forEach((col, index) => {
        headerMap[col] = index;
      });
    }

    const rows = [];
    const invalidRows = [];

    for (let i = startIdx; i < lines.length; i++) {
      const raw = lines[i];
      const cols = [];
      let cur = "";
      let inQuotes = false;

      for (let c = 0; c < raw.length; c++) {
        const ch = raw[c];
        if (ch === '"') {
          inQuotes = !inQuotes;
          continue;
        }
        if (ch === "," && !inQuotes) {
          cols.push(cur.trim());
          cur = "";
        } else {
          cur += ch;
        }
      }
      cols.push(cur.trim());

      // Header varsa mapping kullan, yoksa sıralı parse et
      let name,
        address,
        latStr,
        lngStr,
        textContent,
        audioUrl,
        imageUrl,
        category,
        duration,
        pinOwnerName,
        pinOwnerPhotoUrl;
      let markerType,
        markerSize,
        markerColor,
        markerLetter,
        markerIconUrl,
        markerIconScale;

      if (Object.keys(headerMap).length > 0) {
        // Header mapping ile parse et
        name = cols[headerMap["name"]] || "";
        address = cols[headerMap["address"]] || "";
        latStr = cols[headerMap["lat"]] || "";
        lngStr = cols[headerMap["lng"]] || "";
        textContent = cols[headerMap["textcontent"]] || "";
        audioUrl = cols[headerMap["audiourl"]] || "";
        imageUrl = cols[headerMap["imageurl"]] || "";
        category = cols[headerMap["category"]] || "Standard";
        duration = cols[headerMap["duration"]] || "1_day";
        pinOwnerName = cols[headerMap["pinownername"]] || "";
        pinOwnerPhotoUrl = cols[headerMap["pinownerphotourl"]] || "";
        markerType = cols[headerMap["markertype"]] || "profile";
        markerSize = cols[headerMap["markersize"]] || "medium";
        markerColor = cols[headerMap["markercolor"]] || "#ff2d55";
        markerLetter = cols[headerMap["markerletter"]] || "A";
        markerIconUrl = cols[headerMap["markericonurl"]] || "";
        markerIconScale = cols[headerMap["markericonscale"]] || "1";
      } else {
        // Sıralı parse et
        [
          name,
          address,
          latStr,
          lngStr,
          textContent = "",
          audioUrl = "",
          imageUrl = "",
          category = "Standard",
          duration = "1_day",
          pinOwnerName = "",
          pinOwnerPhotoUrl = "",
          markerType = "profile",
          markerSize = "medium",
          markerColor = "#ff2d55",
          markerLetter = "A",
          markerIconUrl = "",
          markerIconScale = "1",
        ] = cols;
      }

      const lat = parseFloat(latStr);
      const lng = parseFloat(lngStr);
      const ok =
        name &&
        address &&
        typeof lat === "number" &&
        !isNaN(lat) &&
        typeof lng === "number" &&
        !isNaN(lng);

      if (!ok) {
        invalidRows.push({ line: i + 1, raw });
        continue;
      }

      // Marker objesi oluştur
      const marker = { type: markerType, size: markerSize };
      if (markerType === "dot") {
        marker.color = markerColor;
      } else if (markerType === "letter") {
        marker.letter = markerLetter.toUpperCase().slice(0, 1);
        marker.color = markerColor;
      } else if (markerType === "custom") {
        marker.iconUrl = markerIconUrl;
        marker.iconScale = parseFloat(markerIconScale) || 1;
      }

      rows.push({
        id: `csv-${i}`,
        name,
        formatted_address: address,
        geometry: {
          location: {
            lat: Number(lat.toFixed(5)),
            lng: Number(lng.toFixed(5)),
          },
        },
        textContent,
        audioUrl,
        imageUrl,
        category,
        duration,
        pinOwnerName,
        pinOwnerPhotoUrl,
        marker,
      });
    }

    return {
      rows,
      preview: {
        total: lines.length - startIdx,
        valid: rows.length,
        invalid: invalidRows.length,
        invalidRows,
      },
    };
  };

  const handleCsvUpload = (file) => {
    if (!file) return;
    setCsvFileName(file.name);
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = reader.result.toString();
        const { rows, preview } = parseCsvText(text);
        setCsvRows(rows);
        setCsvPreview(preview);
      } catch (e) {
        setCsvRows([]);
        setCsvPreview({ total: 0, valid: 0, invalid: 0, invalidRows: [] });
      }
    };
    reader.readAsText(file, "utf-8");
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoUrl("");
    }
  };

  const handleLogoUrlChange = (event) => {
    const url = event.target.value;
    setLogoUrl(url);
    if (url) {
      setLogoFile(null);
    }
  };

  const updatePinData = (id, field, value) => {
    setCsvRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleAudioFileUpload = async (
    file,
    isTemplate = false,
    rowId = null
  ) => {
    if (!file) return;

    const allowedTypes = [
      "audio/mpeg",
      "audio/wav",
      "audio/mp4",
      "audio/m4a",
      "audio/ogg",
      "audio/aac",
    ];
    if (!allowedTypes.includes(file.type)) {
      alert("Desteklenen ses formatları: MP3, WAV, MP4, M4A, OGG, AAC");
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      // 50MB limit
      alert("Ses dosyası 50MB'dan küçük olmalıdır.");
      return;
    }

    try {
      if (isTemplate) {
        setAudioUploading(true);
      } else {
        setRowAudioUploading((prev) => ({ ...prev, [rowId]: true }));
      }

      const fileName = `audio/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, fileName);

      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      if (isTemplate) {
        setPinTemplate((prev) => ({ ...prev, audioUrl: downloadURL }));
      } else {
        updatePinData(rowId, "audioUrl", downloadURL);
      }
    } catch (error) {
      console.error("Ses dosyası yükleme hatası:", error);
      alert("Ses dosyası yüklenirken hata oluştu.");
    } finally {
      if (isTemplate) {
        setAudioUploading(false);
      } else {
        setRowAudioUploading((prev) => ({ ...prev, [rowId]: false }));
      }
    }
  };

  // Filtreleme fonksiyonu
  const getFilteredRows = () => {
    return csvRows.filter((pin) => {
      return (
        pin.name.toLowerCase().includes(filters.name.toLowerCase()) &&
        pin.category.toLowerCase().includes(filters.category.toLowerCase()) &&
        pin.duration.toLowerCase().includes(filters.duration.toLowerCase()) &&
        (pin.textContent || "")
          .toLowerCase()
          .includes(filters.textContent.toLowerCase())
      );
    });
  };

  // Sıralama fonksiyonu
  const getSortedRows = (rows) => {
    if (!sortConfig.key) return rows;

    return [...rows].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Özel durumlar için değer çıkarma
      if (sortConfig.key === "coordinates") {
        aValue = `${a.geometry?.location?.lat || 0},${
          a.geometry?.location?.lng || 0
        }`;
        bValue = `${b.geometry?.location?.lat || 0},${
          b.geometry?.location?.lng || 0
        }`;
      }

      if (aValue < bValue) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  // Sıralama değiştirme
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Filtre değiştirme
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  // Satır seçimi
  const toggleRowSelection = (pinId) => {
    setSelectedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(pinId)) {
        newSet.delete(pinId);
      } else {
        newSet.add(pinId);
      }
      return newSet;
    });
  };

  // Tümünü seç/seçme
  const toggleSelectAll = () => {
    const filteredRows = getSortedRows(getFilteredRows());
    if (selectedRows.size === filteredRows.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(filteredRows.map((row) => row.id)));
    }
  };

  // Filtrelenmiş ve sıralanmış satırları al
  const displayRows = getSortedRows(getFilteredRows());

  const startEditingRow = (pinId) => {
    setEditingRowId(pinId);
  };

  const saveRowEdit = () => {
    setEditingRowId(null);
  };

  const cancelRowEdit = () => {
    setEditingRowId(null);
  };

  const createBulkPins = async () => {
    if (!campaignName.trim()) {
      alert("Lütfen bir kampanya adı girin.");
      return;
    }

    if (csvRows.length === 0) {
      alert("Lütfen CSV dosyası yükleyin.");
      return;
    }

    setBatchProgress({
      isProcessing: true,
      total: csvRows.length,
      completed: 0,
      successful: 0,
      failed: 0,
      errors: [],
    });

    let successfulCount = 0;
    let failedCount = 0;
    let completedCount = 0;

    try {
      const currentUser = auth.currentUser;
      if (!currentUser)
        throw new Error("Oturum bulunamadı. Lütfen tekrar giriş yapın.");
      const idToken = await currentUser.getIdToken();

      setSuccessSnackbar(false);
      let campaignResponse;

      if (logoFile) {
        const campaignFormData = new FormData();
        campaignFormData.append("name", campaignName);
        campaignFormData.append("logoFile", logoFile);
        const campaignApiUrl = `${getApiBaseUrl()}/campaigns`;
        campaignResponse = await fetch(campaignApiUrl, {
          method: "POST",
          body: campaignFormData,
          headers: { Authorization: `Bearer ${idToken}` },
        }).then((res) => res.json());
        campaignResponse = { data: campaignResponse };
      } else {
        campaignResponse = await apiCall(`/api/campaigns`, {
          method: "POST",
          body: JSON.stringify({
            name: campaignName,
            ...(logoUrl ? { logoUrl } : {}),
          }),
          headers: { Authorization: `Bearer ${idToken}` },
        });
        campaignResponse = { data: campaignResponse };
      }

      if (!campaignResponse.data.success) {
        throw new Error(
          campaignResponse.data.error || "Kampanya oluşturulamadı."
        );
      }

      const newCampaignId = campaignResponse.data.campaign.id;
      const collectedErrors = [];

      // Sadece seçili satırları işle
      const rowsToProcess =
        selectedRows.size > 0
          ? csvRows.filter((row) => selectedRows.has(row.id))
          : csvRows;

      if (rowsToProcess.length === 0) {
        alert("Lütfen işlenecek satırları seçin.");
        setBatchProgress({
          isProcessing: false,
          total: 0,
          completed: 0,
          successful: 0,
          failed: 0,
          errors: [],
        });
        return;
      }

      setBatchProgress({
        isProcessing: true,
        total: rowsToProcess.length,
        completed: 0,
        successful: 0,
        failed: 0,
        errors: [],
      });

      for (const location of rowsToProcess) {
        try {
          if (!location.geometry || !location.geometry.location) {
            failedCount += 1;
            collectedErrors.push(
              `Pin for ${location.name}: Konum bilgisi eksik.`
            );
            continue;
          }

          let latitude =
            location.geometry?.location?.lat ??
            location.lat ??
            location.latitude;
          let longitude =
            location.geometry?.location?.lng ??
            location.lng ??
            location.longitude;
          latitude = parseFloat(latitude);
          longitude = parseFloat(longitude);

          console.log(`${location.name} koordinatları:`, {
            latitude,
            longitude,
            original: location.geometry?.location,
          });

          if (
            typeof latitude !== "number" ||
            isNaN(latitude) ||
            typeof longitude !== "number" ||
            isNaN(longitude)
          ) {
            failedCount += 1;
            collectedErrors.push(
              `Pin için geçersiz koordinat formatı: ${location.name} (lat: ${latitude}, lng: ${longitude})`
            );
            continue;
          }

          const resp = await apiCall(`/api/pins`, {
            method: "POST",
            body: JSON.stringify({
              campaignId: newCampaignId,
              name: location.name,
              address: location.formatted_address,
              latitude,
              longitude,
              textContent: location.textContent || pinTemplate.textContent,
              category: location.category || pinTemplate.category,
              duration: location.duration || pinTemplate.duration,
              pinOwnerName: pinTemplate.pinOwnerName,
              pinOwnerPhotoUrl: pinTemplate.pinOwnerPhotoUrl,
              marker: location.marker || pinTemplate.marker,
              ...(location.audioUrl ? { audioUrl: location.audioUrl } : {}),
              ...(location.imageUrl || pinTemplate.imageUrl
                ? { imageUrl: location.imageUrl || pinTemplate.imageUrl }
                : {}),
            }),
            headers: { Authorization: `Bearer ${idToken}` },
          });

          const respData = { data: resp };
          if (respData.data?.success) {
            successfulCount += 1;
          } else {
            throw new Error(respData.data?.error || "Pin oluşturulamadı");
          }
        } catch (error) {
          failedCount += 1;
          const apiErrorMsg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error.message ||
            "Bilinmeyen hata";
          collectedErrors.push(`Pin for ${location.name}: ${apiErrorMsg}`);
        } finally {
          completedCount += 1;
          setBatchProgress({
            isProcessing: true,
            total: rowsToProcess.length,
            completed: completedCount,
            successful: successfulCount,
            failed: failedCount,
            errors: collectedErrors.slice(),
          });
        }
      }
    } catch (campaignError) {
      console.error("Failed to create campaign:", campaignError);
      alert(`Kampanya oluşturulamadı: ${campaignError.message}`);
      setBatchProgress({
        isProcessing: false,
        total: 0,
        completed: 0,
        successful: 0,
        failed: 0,
        errors: [],
      });
      return;
    }

    setBatchProgress((prev) => ({ ...prev, isProcessing: false }));
    if (successfulCount > 0 && failedCount === 0) {
      setSuccessSnackbar(true);
    }
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 5, boxShadow: 8, background: "#fff" }}>
      <Typography variant="h4" gutterBottom>
        CSV ile Toplu Pin Oluştur
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        CSV dosyası yükleyerek her pin için ayrı açıklama, ses dosyası ve diğer
        detayları özelleştirebilirsiniz.
      </Typography>

      {userFetchError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Kullanıcı listesi yüklenemedi: {userFetchError}
        </Alert>
      )}

      {/* Kampanya Bilgileri */}
      <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            required
            label="Kampanya Adı"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Logo URL'i (Opsiyonel)"
            value={logoUrl}
            onChange={handleLogoUrlChange}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button variant="outlined" component="label" fullWidth>
            Logo Dosyası Seç
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
          </Button>
          {logoFile && (
            <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
              {logoFile.name}
            </Typography>
          )}
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {/* Kampanya Kullanıcısı */}
      <Box sx={{ mb: 2 }}>
        <Autocomplete
          options={campaignUsers}
          getOptionLabel={(option) =>
            option.name ? `${option.name} (${option.email})` : ""
          }
          renderOption={(props, option) => (
            <Box
              component="li"
              {...props}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Avatar
                src={option.photoUrl}
                sx={{ width: 32, height: 32, mr: 1 }}
              />
              <Box>
                <Typography variant="body1" fontWeight={600}>
                  {option.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.email}
                </Typography>
              </Box>
            </Box>
          )}
          value={selectedCampaignUser}
          onChange={(_, value) => {
            if (value && value.id === "new_user") {
              navigate("/user-management?add=true", { replace: true });
            } else {
              setSelectedCampaignUser(value);
              setPinTemplate((prev) => ({
                ...prev,
                pinOwnerName: value?.name || "",
                pinOwnerPhotoUrl: value?.photoUrl || "",
              }));
            }
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          noOptionsText={<span>Hiç kullanıcı yok</span>}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kampanya Kullanıcısı"
              fullWidth
              InputProps={{ ...params.InputProps, sx: { borderRadius: 3 } }}
            />
          )}
          sx={{ width: "100%" }}
        />
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* CSV Yükleme */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          CSV Dosyası Yükle
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
          }}
        >
          <Button variant="outlined" onClick={downloadSampleCsv}>
            Örnek CSV indir
          </Button>
          <Button
            variant="contained"
            component="label"
            startIcon={<UploadIcon />}
          >
            CSV Dosyası Seç
            <input
              type="file"
              accept=".csv,text/csv"
              hidden
              onChange={(e) => handleCsvUpload(e.target.files[0])}
            />
          </Button>
          {csvFileName && (
            <Typography variant="body2">Seçilen: {csvFileName}</Typography>
          )}
        </Box>

        {csvPreview.total > 0 && (
          <Paper sx={{ p: 2, mb: 2 }}>
            <Typography variant="subtitle2">Ön izleme</Typography>
            <Typography variant="body2">
              Toplam: {csvPreview.total} | Geçerli: {csvPreview.valid} | Hatalı:{" "}
              {csvPreview.invalid}
            </Typography>
            {csvPreview.invalid > 0 && (
              <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  CSV Formatı:
                </Typography>
                <Typography variant="body2" component="div">
                  <strong>Zorunlu sütunlar:</strong> name, address, lat, lng
                  <br />
                  <strong>Opsiyonel sütunlar:</strong> textContent, audioUrl,
                  category, duration, pinOwnerName, pinOwnerPhotoUrl,
                  markerType, markerSize, markerColor, markerLetter,
                  markerIconUrl, markerIconScale
                  <br />
                  <strong>Kategori değerleri:</strong> Standard, Premium, VIP
                  <br />
                  <strong>Süre değerleri:</strong> 1_day, 3_days, 1_week,
                  1_month, 3_months, 6_months, 1_year, permanent
                  <br />
                  <strong>Marker türleri:</strong> profile, dot, letter, custom
                </Typography>
              </Alert>
            )}
          </Paper>
        )}
      </Box>

      {/* Pin Detayları Düzenleme Tablosu */}
      {csvRows.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box>
              <Typography variant="h6">Pin Detaylarını Özelleştir</Typography>
              <Typography variant="body2" color="text.secondary">
                Toplam: {csvRows.length} | Görüntülenen: {displayRows.length} |
                Seçili: {selectedRows.size}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<FilterListIcon />}
                onClick={() => setShowFilters(!showFilters)}
              >
                {showFilters ? "Filtreleri Gizle" : "Filtrele"}
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={
                  selectedRows.size === displayRows.length ? (
                    <ClearAllIcon />
                  ) : (
                    <SelectAllIcon />
                  )
                }
                onClick={toggleSelectAll}
              >
                {selectedRows.size === displayRows.length
                  ? "Hiçbirini Seçme"
                  : "Tümünü Seç"}
              </Button>
            </Box>
          </Box>

          {/* Filtre Satırı */}
          {showFilters && (
            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 2 }}>
                Filtreler
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Konum Ara"
                    value={filters.name}
                    onChange={(e) => handleFilterChange("name", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Açıklama Ara"
                    value={filters.textContent}
                    onChange={(e) =>
                      handleFilterChange("textContent", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Kategori</InputLabel>
                    <Select
                      value={filters.category}
                      label="Kategori"
                      onChange={(e) =>
                        handleFilterChange("category", e.target.value)
                      }
                    >
                      <MenuItem value="">Tümü</MenuItem>
                      {categories.map((c) => (
                        <MenuItem key={c} value={c}>
                          {c}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Süre</InputLabel>
                    <Select
                      value={filters.duration}
                      label="Süre"
                      onChange={(e) =>
                        handleFilterChange("duration", e.target.value)
                      }
                    >
                      <MenuItem value="">Tümü</MenuItem>
                      {durationOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          )}

          <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <input
                      type="checkbox"
                      checked={
                        selectedRows.size === displayRows.length &&
                        displayRows.length > 0
                      }
                      onChange={toggleSelectAll}
                    />
                  </TableCell>
                  <TableCell
                    sx={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("name")}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      Konum
                      {sortConfig.key === "name" &&
                        (sortConfig.direction === "asc" ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : (
                          <ArrowDownwardIcon fontSize="small" />
                        ))}
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("coordinates")}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      Koordinatlar
                      {sortConfig.key === "coordinates" &&
                        (sortConfig.direction === "asc" ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : (
                          <ArrowDownwardIcon fontSize="small" />
                        ))}
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("textContent")}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      Açıklama
                      {sortConfig.key === "textContent" &&
                        (sortConfig.direction === "asc" ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : (
                          <ArrowDownwardIcon fontSize="small" />
                        ))}
                    </Box>
                  </TableCell>
                  <TableCell>Marker</TableCell>
                  <TableCell>Ses URL</TableCell>
                  <TableCell
                    sx={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("category")}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      Kategori
                      {sortConfig.key === "category" &&
                        (sortConfig.direction === "asc" ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : (
                          <ArrowDownwardIcon fontSize="small" />
                        ))}
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleSort("duration")}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      Süre
                      {sortConfig.key === "duration" &&
                        (sortConfig.direction === "asc" ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : (
                          <ArrowDownwardIcon fontSize="small" />
                        ))}
                    </Box>
                  </TableCell>
                  <TableCell>İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayRows.map((pin) => (
                  <TableRow
                    key={pin.id}
                    sx={{
                      backgroundColor: selectedRows.has(pin.id)
                        ? "rgba(25, 118, 210, 0.08)"
                        : "inherit",
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
                    }}
                  >
                    <TableCell padding="checkbox">
                      <input
                        type="checkbox"
                        checked={selectedRows.has(pin.id)}
                        onChange={() => toggleRowSelection(pin.id)}
                      />
                    </TableCell>
                    <TableCell sx={{ minWidth: 150 }}>
                      <Typography variant="body2" fontWeight={600}>
                        {pin.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {pin.formatted_address}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ minWidth: 120 }}>
                      <Typography variant="body2" fontFamily="monospace">
                        {pin.geometry?.location?.lat?.toFixed(4) || "N/A"},{" "}
                        {pin.geometry?.location?.lng?.toFixed(4) || "N/A"}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block" }}
                      >
                        Raw: lat={pin.geometry?.location?.lat}, lng=
                        {pin.geometry?.location?.lng}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ minWidth: 200 }}>
                      {editingRowId === pin.id ? (
                        <TextField
                          fullWidth
                          multiline
                          rows={2}
                          value={pin.textContent}
                          onChange={(e) =>
                            updatePinData(pin.id, "textContent", e.target.value)
                          }
                          placeholder="Pin açıklaması..."
                          size="small"
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{ wordBreak: "break-word" }}
                        >
                          {pin.textContent || "Açıklama yok"}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 80, textAlign: "center" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {logoUrl || logoFile ? (
                          <img
                            src={
                              logoUrl ||
                              (logoFile ? URL.createObjectURL(logoFile) : null)
                            }
                            alt="Kampanya Logosu"
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #1976d2",
                            }}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              backgroundColor: "#1976d2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            📍
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ minWidth: 200 }}>
                      {editingRowId === pin.id ? (
                        <Box>
                          <RadioGroup
                            row
                            value={pin.audioInputType || "url"}
                            onChange={(e) =>
                              updatePinData(
                                pin.id,
                                "audioInputType",
                                e.target.value
                              )
                            }
                            sx={{ mb: 1 }}
                          >
                            <FormControlLabel
                              value="url"
                              control={<Radio size="small" />}
                              label="URL"
                            />
                            <FormControlLabel
                              value="file"
                              control={<Radio size="small" />}
                              label="Dosya"
                            />
                          </RadioGroup>

                          {(pin.audioInputType || "url") === "url" ? (
                            <TextField
                              fullWidth
                              value={pin.audioUrl}
                              onChange={(e) =>
                                updatePinData(
                                  pin.id,
                                  "audioUrl",
                                  e.target.value
                                )
                              }
                              placeholder="Ses dosyası URL'si..."
                              size="small"
                            />
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="outlined"
                                component="label"
                                size="small"
                                startIcon={<UploadIcon />}
                                disabled={rowAudioUploading[pin.id]}
                              >
                                {rowAudioUploading[pin.id]
                                  ? "Yükleniyor..."
                                  : "Ses Seç"}
                                <input
                                  type="file"
                                  hidden
                                  accept="audio/*"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file)
                                      handleAudioFileUpload(
                                        file,
                                        false,
                                        pin.id
                                      );
                                  }}
                                />
                              </Button>
                              {pin.audioUrl && (
                                <Typography
                                  variant="caption"
                                  color="success.main"
                                >
                                  ✓ Yüklendi
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Box>
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{ wordBreak: "break-all" }}
                        >
                          {pin.audioUrl || "Ses yok"}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {editingRowId === pin.id ? (
                        <FormControl fullWidth size="small">
                          <Select
                            value={pin.category}
                            onChange={(e) =>
                              updatePinData(pin.id, "category", e.target.value)
                            }
                          >
                            {categories.map((c) => (
                              <MenuItem key={c} value={c}>
                                {c}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <Typography variant="body2">{pin.category}</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {editingRowId === pin.id ? (
                        <FormControl fullWidth size="small">
                          <Select
                            value={pin.duration}
                            onChange={(e) =>
                              updatePinData(pin.id, "duration", e.target.value)
                            }
                          >
                            {durationOptions.map((opt) => (
                              <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <Typography variant="body2">
                          {durationOptions.find((d) => d.value === pin.duration)
                            ?.label || pin.duration}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {editingRowId === pin.id ? (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Tooltip title="Kaydet">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={saveRowEdit}
                            >
                              <SaveIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="İptal">
                            <IconButton
                              size="small"
                              color="secondary"
                              onClick={cancelRowEdit}
                            >
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : (
                        <Tooltip title="Düzenle">
                          <IconButton
                            size="small"
                            onClick={() => startEditingRow(pin.id)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* Varsayılan Şablon */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Varsayılan Pin Şablonu
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Bu ayarlar, yukarıda özelleştirilmemiş pinler için kullanılacak.
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Varsayılan Pin Metni"
              value={pinTemplate.textContent}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  textContent: e.target.value,
                }))
              }
              fullWidth
              multiline
              rows={2}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Kategori</InputLabel>
              <Select
                value={pinTemplate.category}
                label="Kategori"
                onChange={(e) =>
                  setPinTemplate((prev) => ({
                    ...prev,
                    category: e.target.value,
                  }))
                }
              >
                {categories.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Süre</InputLabel>
              <Select
                value={pinTemplate.duration}
                label="Süre"
                onChange={(e) =>
                  setPinTemplate((prev) => ({
                    ...prev,
                    duration: e.target.value,
                  }))
                }
              >
                {durationOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Varsayılan Ses</FormLabel>
              <RadioGroup
                row
                value={pinTemplate.audioInputType}
                onChange={(e) =>
                  setPinTemplate((prev) => ({
                    ...prev,
                    audioInputType: e.target.value,
                    audioUrl: "",
                  }))
                }
                sx={{ mb: 2 }}
              >
                <FormControlLabel value="url" control={<Radio />} label="URL" />
                <FormControlLabel
                  value="file"
                  control={<Radio />}
                  label="Dosya Yükle"
                />
              </RadioGroup>

              {pinTemplate.audioInputType === "url" ? (
                <TextField
                  fullWidth
                  label="Ses URL'si"
                  value={pinTemplate.audioUrl}
                  onChange={(e) =>
                    setPinTemplate((prev) => ({
                      ...prev,
                      audioUrl: e.target.value,
                    }))
                  }
                  placeholder="https://example.com/audio.mp3"
                />
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<UploadIcon />}
                    disabled={audioUploading}
                  >
                    {audioUploading ? "Yükleniyor..." : "Ses Dosyası Seç"}
                    <input
                      type="file"
                      hidden
                      accept="audio/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) handleAudioFileUpload(file, true);
                      }}
                    />
                  </Button>
                  {audioUploading && <CircularProgress size={20} />}
                  {pinTemplate.audioUrl && (
                    <Typography variant="body2" color="success.main">
                      ✓ Dosya yüklendi
                    </Typography>
                  )}
                </Box>
              )}
            </FormControl>
          </Grid>

          {/* Resim URL */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Resim URL (Opsiyonel)"
              value={pinTemplate.imageUrl}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  imageUrl: e.target.value,
                }))
              }
              placeholder="https://example.com/image.jpg"
              helperText="Tüm pin'lere eklenecek resim URL'si"
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Oluştur Butonu */}
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            borderRadius: 4,
            px: 6,
            py: 2,
            fontWeight: 700,
            fontSize: 20,
            boxShadow: 4,
          }}
          startIcon={
            batchProgress.isProcessing ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              <CheckIcon />
            )
          }
          disabled={
            batchProgress.isProcessing ||
            successSnackbar ||
            !selectedCampaignUser ||
            !campaignName.trim() ||
            csvRows.length === 0 ||
            (selectedRows.size === 0 && csvRows.length > 0)
          }
          onClick={createBulkPins}
        >
          Toplu Pin Oluştur
        </Button>

        {batchProgress.errors.length > 0 && (
          <Box sx={{ width: "100%", mt: 3 }}>
            {batchProgress.errors.map((err, idx) => (
              <Alert severity="error" key={idx} sx={{ mb: 1, borderRadius: 2 }}>
                {err}
              </Alert>
            ))}
          </Box>
        )}

        {batchProgress.isProcessing && (
          <Box sx={{ width: "100%", mt: 3 }}>
            <LinearProgress
              variant="determinate"
              value={
                batchProgress.total > 0
                  ? (batchProgress.completed / batchProgress.total) * 100
                  : 0
              }
              sx={{ height: 8, borderRadius: 4 }}
            />
            <Typography variant="body2" sx={{ mt: 1 }}>
              {`İşlemde: ${batchProgress.completed}/${batchProgress.total} | Başarılı: ${batchProgress.successful} | Hatalı: ${batchProgress.failed}`}
            </Typography>
          </Box>
        )}
      </Box>

      <Snackbar
        open={successSnackbar}
        autoHideDuration={4000}
        onClose={() => setSuccessSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setSuccessSnackbar(false)}
          sx={{ borderRadius: 2 }}
        >
          Tüm pinler başarıyla oluşturuldu!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default CSVBulkPinCreationPage;
